export default __webpack_public_path__ + "static/media/1.3df50d76.jpg";